
import Icon from 'src/assets/icon.svg';
import LogoDark from 'src/assets/logo-dark.svg';
import React, { useEffect, useState } from "react";
import { items } from "./NavItems";

import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setIsLogged, setToken, setData } from "@auth/Actions";
import { useDispatch } from "react-redux";
import { Sidenav, Nav, HStack, VStack } from 'rsuite';
import { setSectionName } from '@services/redux/slices/globalSlice';


function SideNavBar() {
  const [expanded, setExpanded] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // Détecter la taille de l'écran
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Forcer expanded à false sur mobile
      if (mobile) {
        setExpanded(false);
      } else {
        setExpanded(true);
      }
    };

    // Vérifier au chargement initial
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const getActiveButton = () => {
    const path = location.pathname;
    if (path === "/" || path === "/dashboard") return "dashboard";
    return path.substring(1);
  };

  const handleClick = (item) => {
    if (item.value === "quit") {
      dispatch(setIsLogged(false));
      dispatch(setToken(""));
      dispatch(setData([]));
      window.location = "/login";
    } else {
      navigate(`/${item.value}`);
      dispatch(setSectionName(item.sectionName))
    }
  };

  const boutonActif = getActiveButton();

  const Header = ({ expanded, onClick }) => {
    if (!expanded) {
      return (
        <HStack justifyContent="center">
          <img
            src={Icon}
            alt="Brand icon"
            className='cursor-pointer'
            style={{ width: 24, height: 24, cursor: "pointer" }}
            onClick={onClick}
          />
        </HStack>
      );
    }

    return (
      <VStack p="10px 10px 0 10px" spacing={12}>
        <HStack>
          <img
            src={LogoDark}
            alt="Brand logo"
            style={{ height: 24 }}
            onClick={onClick}
            className='px-3 cursor-pointer'
          />
        </HStack>
      </VStack>
    );
  };

  return (
    <Sidenav 
      expanded={expanded} 
      width={expanded ? 260 : 56}
      className="h-100 bg-white"
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
         width: expanded ? 240 : 56
      }}
    >
      <Sidenav.Header className='mt-4'>
        <Header expanded={expanded} onClick={() => navigate("/dashboard")} />
      </Sidenav.Header>
      <Sidenav.Body className='pt-4' style={{ flex: 1, overflow: "hidden" }}>
        <Nav style={{ height: "100%", overflowY: "auto" }}>
          {items.map((item) => (
            <Nav.Item
              key={item.id}
              className={`fs-6 fw-medium bg-white border-0 ${
                boutonActif === item.value ? "text-blue" : ""
              }`}
              eventKey={item.id}
              icon={item.icon}
              onClick={() => handleClick(item)}
            >
              {t(item.title)}
            </Nav.Item>
          ))}
        </Nav>
      </Sidenav.Body>
      <div style={{ marginTop: 'auto' }} className='p-1 text-blue d-none d-md-block'>
        <Sidenav.Toggle onToggle={setExpanded} />
      </div>
    </Sidenav>
  );
}

export default SideNavBar;






// import { Sidebar, Sidenav, Nav } from "rsuite";
// import React, { useState } from "react";
// import { items } from "./NavItems";
// import Logo from "@components/Logo";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { setIsLogged, setToken, setData } from "@auth/Actions";
// import { useDispatch } from "react-redux";


// function SideNavBar({ profile, theme }) {
//   const [expand] = useState(false);
//   const location = useLocation();

//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   const dispatch = useDispatch();


//   const getActiveButton = () => {
//     const path = location.pathname;
//     if (path === "/" || path === "/dashboard") return "dashboard";
//     return path.substring(1);
//   };

//   const handleClick = (value) => {
//     if (value === "quit") {
//       dispatch(setIsLogged(false));
//       dispatch(setToken(""));
//       dispatch(setData([]));
//       window.location = "/login";
//     } else {
//       navigate(`/${value}`);
//     }
//   };

//   const boutonActif = getActiveButton();
//   const separator = items.length - 2;
//   return (
//     <Sidebar
//       style={{ display: "flex", flexDirection: "column", height: "100vh" }}
//       width={expand ? 260 : 56}
//       collapsible
//       className={`sidebar-sticky rounsded-3 ${theme.nav}`}
//     >
//       <Sidenav
//         expanded={expand}
//         defaultOpenKeys={["3"]}
//         className="h-100 bg-white"
//       >
//         <Sidenav.Body className="h-100 bg-white">
//           <div className="d-flex flex-column justify-content-between h-100 bg-white">
//             <Nav className="bg-white">
//               <div className="w-100 p-3 ">
//                 <Logo width={100} />
//                 <hr className="border-secondary " />
//               </div>

//               {items.slice(0, separator).map((item) => (
//                 <Nav.Item
//                   key={item.id}
//                   className={`fs-6 fw-light bg-white border-0 ${
//                     boutonActif === item.value ? "text-blue" : ""
//                   }`}
//                   eventKey={item.id}
//                   icon={item.icon}
//                   onClick={() => handleClick(item.value)}
//                 >
//                   {t(item.title)}
//                 </Nav.Item>
//               ))}
//             </Nav>

//             <Nav>
//               {items.slice(separator, items.length).map((item) => (
//                 <Nav.Item
//                   key={item.id}
//                   className={`fs-6 bg-white fw-light ${
//                     boutonActif === item.value ? "text-blue" : ""
//                   }`}
//                   eventKey={item.id}
//                   icon={item.icon}
//                   onClick={() => handleClick(item.value)}
//                 >
//                   {t(item.title)}
//                 </Nav.Item>
//               ))}
//             </Nav>
//           </div>
//         </Sidenav.Body>
//       </Sidenav>
//     </Sidebar>
    



//   );
// }

// export default SideNavBar;
